<app-leveltwo [pastEvents]="true" [pageName]="'General Info'">
  <div class="General">
    <h3>{{'Events.SearchTitle'|translate}}</h3>

    <!-- <h4>{{'Events.Comebacksoon2'|translate}}</h4> -->

      <!-- <p>{{'Events.TheLosAngeles2'|translate}}</p>



      <hr style="background-color:black;">
      <div class="row">
       <div class="col-sm-3" >
        <div >
          <a  href="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1741276825/Events/Disaster_Relief_Webinar_2025.pdf" target="_blank" title="flyer"><img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1741276825/Events/Disaster_Relief_Thumbnail_2025.jpg"  height="300" alt="flyer" style="border-width: .1rem; border-color: black; border-style: solid;" ></a>
        </div>
        <i>{{'Events.ClicktoviewEN'|translate}}</i>

        </div>
        <div class="col-sm-8">
          <br>
          <p [innerHTML]="'Events.Mar132025v3'|translate"></p>


          <a class="btn btn-primary mb-4" href="https://assessor-lacounty-gov.zoom.us/webinar/register/WN_3nfGKrTNTnCr1yGJ9ugK3w#/registration" target="_blank">
            <span [innerHTML]="'Events.ZoomRegLink'|translate"></span>
          </a>
          &nbsp;

        </div>

      </div> -->

      <hr style="background-color:black;">
      <div class="row">
       <div class="col-sm-3" >
        <div >
          <a  href="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1744042793/Events/WESTSIDE_FAIR_Resource_Fair.pdf" target="_blank" title="flyer"><img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1744042793/Events/WESTSIDE_FAIR_DRAFT_1.png"  height="300" alt="flyer" style="border-width: .1rem; border-color: black; border-style: solid;" ></a>
        </div>
        <i>{{'Events.ClicktoviewEN'|translate}}</i>

        </div>
        <div class="col-sm-8">
          <br>
          <p [innerHTML]="'Events.Apr272025'|translate"></p>


          <a class="btn btn-primary mb-4" href="https://forms.office.com/Pages/ResponsePage.aspx?id=SHJZBzjqG0WKvqY47dusgVfKIHqxm0NHtHEbTIciajFUM0sySVdEWDRZQUY5VkRJV0tNTUc0MFNHMi4u" target="_blank">
            <span [innerHTML]="'Home.RegisterToday'|translate"></span>
          </a>
          &nbsp;

        </div>

      </div>

      <!-- <hr style="background-color:black;">
      <div class="row">
        <div class="col-sm-3" >
         <div >
           <a  href="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1711061238/Events/Boat_and_Vessel_Town_Hall.pdf" target="_blank" title="flyer"><img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1711053316/Events/Boat_Town_Hall_thumbnail.png"  height="300" alt="flyer" style="border-width: .1rem; border-color: black; border-style: solid;" ></a>
         </div>
         <i>{{'Events.ClicktoviewEN'|translate}}</i>

         </div>
         <div class="col-sm-8">
           <br>
           <p [innerHTML]="'Events.Apr92024'|translate"></p>
          <p>
            <strong>Burton Chase Park</strong><br>
            13650 Mindanao Way<br>
            Marina del Rey, CA 90292
          </p>

           <a class="btn btn-primary mb-4" href="https://forms.office.com/g/NxSrYPDQRm " target="_blank">
             <span>{{'Events.Register'|translate}}</span>
           </a>
           &nbsp;

         </div>

       </div> -->

      <!-- <hr style="background-color:black;">
      <div class="row">
       <div class="col-sm-3" >
        <div >
          <a  href="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1670452163/Events/CCAITA_Agenda_12.12.22_final.pdf" target="_blank" title="flyer"><img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1670452163/Events/CCAITA_Agenda_Thumbnail.jpg"  height="300" alt="flyer" style="border-width: .1rem; border-color: black; border-style: solid;" ></a>
        </div>
        <i>{{'Events.ClickAgenda'|translate}}</i>

      </div>
       <div class="col-sm-8">
        <br>
        <p [innerHTML]="'Events.Dec122022'|translate"></p>
        <a class="btn btn-primary mb-4" href="https://us06web.zoom.us/j/87517176050?pwd=YnFkZFp1bVcxZlRubHFjNGFwSGQzUT09" target="_blank">
          <span>{{'Events.JoinZoom'|translate}}</span>
        </a>
      </div>

      </div>
      <hr style="background-color:black;"> -->



      <!-- <div class="row">

        <div class="col-sm-3" >
          <div >
            <a  href="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1695248582/Events/HORF_Oct_2023.pdf" target="_blank" title="flyer"><img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1695248655/Events/HORF_Oct_2023jpg.png"  height="300" alt="flyer" style="border-width: .1rem; border-color: black; border-style: solid;"></a>
          </div>
          {{'Events.ClicktoviewEN'|translate}}

        </div>

        <div class="col-sm-8">

          <p [innerHTML]="'Events.Oct142023-HORF'|translate"></p>
          <a class="btn btn-primary mb-4" href="https://forms.office.com/g/SN3nn1977j " target="_blank">
            <span>{{'Events.Registernow'|translate}}</span>
          </a>
        </div>
      </div> -->


      <!-- <hr>

      <div class="row">

        <div class="col-sm-3" >
          <div >
            <a  href="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1647881103/Events/Virtual_Business_Personal_Property_Statement.jpg" target="_blank" title="flyer"><img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1647881103/Events/Virtual_Business_Personal_Property_Statement.jpg"  height="300" alt="flyer"></a>
          </div>
          <div>
            <a href="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1647884537/Events/571_Spanish_Flyer.jpg" target="_blank">Spanish Flyer</a>
          </div>


        </div>

        <div class="col-sm-8">

          <p [innerHTML]="'Events.Mar292022'|translate"></p>
          <a class="btn btn-primary mb-4" href="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1675281038/Events/HORF_-_March_2023.jpg" target="_blank">
            <span>{{'Events.Registernow'|translate}}</span>
          </a>
          &nbsp;
          <a class="btn btn-primary mb-4" href="/news-information/webinars-presentations">
            <span>{{'Events.WatchVid'|translate}}</span>
          </a>
        </div>
      </div> -->





  </div>
  <div class="past">
    <div class="General">
      <h3>{{'Events.PastEvents'|translate}}</h3>
      <div class="row">
        <div class="col-sm-3">
          <a  href="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1744040596/Events/Past%20Events/2025_Disaster_Relief_RF.jpg" target="_blank" title="flyer"><img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1744040596/Events/Past%20Events/2025_Disaster_Relief_RF.jpg"  height="300" alt="flyer" style="border-width: .1rem; border-color: black; border-style: solid;" ></a>
        </div>
        <div class="col-sm-3">
          <a  href="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1742305288/Events/Past%20Events/Disaster_Relief_Webinar_2025_1.pdf" target="_blank" title="flyer"><img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1742305289/Events/Past%20Events/Disaster_Relief_Webinar_-_thumbnail.jpg"  height="300" alt="flyer" style="border-width: .1rem; border-color: black; border-style: solid;" ></a>
        </div>
        <div class="col-sm-3">
          <a  href="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1741276393/Events/Past%20Events/2025_BPP_Webinar_Flyer_1.pdf" target="_blank" title="flyer"><img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1741276392/Events/Past%20Events/BPP_Webinar_2025.jpg"  height="300" alt="flyer" style="border-width: .1rem; border-color: black; border-style: solid;" ></a>
        </div>
        <div class="col-sm-3">
          <a  href="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1731438974/Events/Past%20Events/HORF_2024_Torrance_Final.pdf" target="_blank" title="flyer"><img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1731438971/Events/Past%20Events/2024Torrance_HORF_thumbnail.jpg"  height="300" alt="flyer" style="border-width: .1rem; border-color: black; border-style: solid;" ></a>
        </div>
        <div class="col-sm-3">
          <a  href="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1712612084/Events/Past%20Events/Boat_and_Vessel_Town_Hall.pdf" target="_blank" title="flyer"><img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1712612084/Events/Past%20Events/boat_and_vessel_thumbnail.jpg"  height="300" alt="flyer" style="border-width: .1rem; border-color: black; border-style: solid;" ></a>
        </div>
        <div class="col-sm-3">
          <a  href="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1710868430/Events/2024_571-L_EN.pdf" target="_blank" title="flyer"><img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1711640424/Events/Past%20Events/2024bpp_thumbnail.jpg"  height="300" alt="flyer" style="border-width: .1rem; border-color: black; border-style: solid;" ></a>
        </div>
        <div class="col-sm-3">
          <a  href="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1702394715/Events/HORF_-_Save_the_Date_Flyer.png" target="_blank" title="flyer"><img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1702394715/Events/HORF_-_Save_the_Date_Flyer.png"  height="300" alt="flyer" style="border-width: .1rem; border-color: black; border-style: solid;" ></a>
        </div>
        <div class="col-sm-3">
          <a  href="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1695248582/Events/HORF_Oct_2023.pdf" target="_blank" title="flyer"><img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1695248655/Events/HORF_Oct_2023jpg.png"  height="300" alt="flyer" style="border-width: .1rem; border-color: black; border-style: solid;" ></a>
        </div>
        <div class="col-sm-3">
          <a  href="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1679347719/Events/571-L_Webinar_2023_Flyer.pdf" target="_blank" title="flyer"><img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1680193576/Events/2023_571L_thumbnail.jpg"  height="300" alt="flyer" style="border-width: .1rem; border-color: black; border-style: solid;" ></a>
        </div>
        <div class="col-sm-3">
          <a  href="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1678897595/Events/Past%20Events/HORF_TC_2023.jpg" target="_blank" title="flyer"><img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1678897595/Events/Past%20Events/HORF_TC_2023.jpg"  height="300" alt="flyer" style="border-width: .1rem; border-color: black; border-style: solid;" ></a>
        </div>
        <div class="col-sm-3">
          <a  href="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1669831045/Events/JPrang_Oath_of_Office_2022.pdf" target="_blank" title="flyer"><img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1670946840/Events/Past%20Events/oath_of_office.jpg"  height="300" alt="flyer" style="border-width: .1rem; border-color: black; border-style: solid;" ></a>
        </div>
        <div class="col-sm-3">
          <a  href="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1667315080/Events/HORF_2022.pdf" target="_blank" title="flyer"><img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1667315388/Events/fall_horf_thumbnail.jpg"  height="300" alt="flyer" style="border-width: .1rem; border-color: black; border-style: solid;" ></a>
        </div>
        <div class="col-sm-3">
          <a  href="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1652388172/Events/Resource_Fair_PDF_-_Update.pdf" target="_blank" title="flyer"><img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1653321411/Events/Past%20Events/horf_thumbnail.jpg"  height="300" alt="flyer" ></a>
        </div>
        <div class="col-sm-3">
          <a  href="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1652819411/Events/Past%20Events/BPP_Flyer.pdf" target="_blank" title="flyer"><img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1652819408/Events/Past%20Events/bpp_thumbnail.jpg"  height="300" alt="flyer" ></a>
        </div>
        <div class="col-sm-3">
          <a  href="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1652819410/Events/Past%20Events/ADU_Seminar.pdf" target="_blank" title="flyer"><img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1652819409/Events/Past%20Events/adu_thumbnail.png"  height="300" alt="flyer" ></a>
        </div>
        <div class="col-sm-3">
          <a  href="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1652819408/Events/Past%20Events/ASSR_Covid-19_Vaccinations_Testing.pdf" target="_blank" title="flyer"><img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1652819408/Events/Past%20Events/covid19_thumbnail.jpg"  height="300" alt="flyer" style="border-width: .1rem; border-color: black; border-style: solid;"></a>
        </div>
        <div class="col-sm-3">
          <a  href="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1652819409/Events/Past%20Events/Prop_19_Townhall.pdf" target="_blank" title="flyer"><img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1652819409/Events/Past%20Events/prop19townhall_thumbnail.jpg"  height="300" alt="flyer" style="border-width: .1rem; border-color: black; border-style: solid;"></a>
        </div>

        <div class="col-sm-3">
          <a  href="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1652819409/Events/Past%20Events/Glendora_Council.pdf" target="_blank" title="flyer"><img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1652819408/Events/Past%20Events/gcc_thumbnail.jpg"  height="300" alt="flyer" ></a>
        </div>
        <div class="col-sm-3">
          <a  href="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1652819415/Events/Past%20Events/SONC.pdf" target="_blank" title="flyer"><img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1652819409/Events/Past%20Events/sonc_thumbnail.jpg"  height="300" alt="flyer" ></a>
        </div>
        <div class="col-sm-3">
          <a  href="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1652819409/Events/Past%20Events/Faith.pdf" target="_blank" title="flyer"><img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1652819409/Events/Past%20Events/report_thumnail.jpg"  height="300" alt="flyer" ></a>
        </div>
      </div>
    </div>
  </div>

</app-leveltwo>

